export const HELP_CENTER_MENU = {
  items: {
    contact: 'Contact Support',
    gettingStarted: 'Getting Started',
    helpCenter: 'Help Center',
    termsOfService: 'Terms and Service',
    privacyPolicy: 'Privacy Policy',
  },
  contact: {
    contactToastTitle: 'Email copied to clipboard',
    contactToastMessage:
      "We've copied our support email to your clipboard. Get in touch for support.",
    contactEmail: 'restaurantsupport@poly-ai.com',
  },
};
